module.exports = __webpack_public_path__ + "img/901628273.f16d766e.png";